import { GroupchatChannelRegistryService } from 'src/app/shared/services/groupchat-channel-registry.service';
import { BlocklyHelperService } from '../blockly-helper.service';
import { BLOCKLY_DUMMY, BlocklyToolboxCategory } from '../blocky-types.types';
import { registerGroupchatChannelDropdownBlock } from '../field-groupchat-channel-dropdown';

/**
 * Experten-Kategorien: Jeder RAGAI Sub-Service als eigene Kategorie
 * mit allen öffentlichen Methoden als Blockly-Blöcke.
 * Methoden mit Parametern nutzen Zod-Overloads mit JSON-Eingabe.
 */

export function ExpertCategory_MSG(name: string, BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', name, contents: [] };
  cat.contents = [
    BH.expertObj("EXPERT_MSG_PROMPT_OBJ", "MSG.prompt({{obj[@check=RAGAIOBJ]}})", "RAGAI.MSG.prompt({{obj}});", '{"text": ""}'),
    BH.expertObj("EXPERT_MSG_USERMESSAGE_OBJ", "MSG.userMessage({{obj[@check=RAGAIOBJ]}})", "RAGAI.MSG.userMessage({{obj}});", '{"text": ""}'),
    BH.expertObj("EXPERT_MSG_BOTBYPASS_OBJ", "@output:String\nMSG.botBypass({{obj[@check=RAGAIOBJ]}})", "await RAGAI.MSG.botBypass({{obj}})", '{"text": ""}'),
    BH.expertObj("EXPERT_MSG_USERBYPASS_OBJ", "@output:String\nMSG.userBypass({{obj[@check=RAGAIOBJ]}})", "await RAGAI.MSG.userBypass({{obj}})", '{"text": ""}'),
    BH.expertObj("EXPERT_MSG_BOTMESSAGE_OBJ", "@output:String\nMSG.botMessage({{obj[@check=RAGAIOBJ]}})", "await RAGAI.MSG.botMessage({{obj}})", '{"text": ""}'),
    BH.expertObj("EXPERT_MSG_OVERWRITESYSTEMPROMPT_OBJ", "MSG.overwriteSystemPrompt({{obj[@check=RAGAIOBJ]}})", "await RAGAI.MSG.overwriteSystemPrompt({{obj}});", '{"prompt": ""}'),
    BH.expertObj("EXPERT_MSG_OVERWRITEWEBSEARCH_OBJ", "MSG.overwriteWebsearchEnabled({{obj[@check=RAGAIOBJ]}})", "await RAGAI.MSG.overwriteWebsearchEnabled({{obj}});", '{"enabled": true}')
  ];
  return cat;
}

export function ExpertCategory_KEYVAL(name: string, BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', name, contents: [] };
  cat.contents = [
    BH.expertObj("EXPERT_KEYVAL_SET_OBJ", "KEYVAL.set({{obj[@check=RAGAIOBJ]}})", "await RAGAI.KEYVAL.set({{obj}});", '{"key": "", "value": "", "type": "custom"}'),
    BH.expertObj("EXPERT_KEYVAL_UNIQUE_OBJ", "KEYVAL.unique({{obj[@check=RAGAIOBJ]}})", "await RAGAI.KEYVAL.unique({{obj}});", '{"key": "", "value": "", "type": "custom"}'),
    BH.expertObj("EXPERT_KEYVAL_GET_OBJ", "@output:String\nKEYVAL.get({{obj[@check=RAGAIOBJ]}})", "await RAGAI.KEYVAL.get({{obj}})", '{"key": "", "type": "custom"}'),
    BH.expertObj("EXPERT_KEYVAL_GETBYTYPE_OBJ", "@output:String\nKEYVAL.getByType({{obj[@check=RAGAIOBJ]}})", "await RAGAI.KEYVAL.getByType({{obj}})", '{"type": "custom"}'),
    BH.expertObj("EXPERT_KEYVAL_DELETE_OBJ", "KEYVAL.deleteKeyValEntry({{obj[@check=RAGAIOBJ]}})", "await RAGAI.KEYVAL.deleteKeyValEntry({{obj}});", '{"key": "", "type": "custom"}')
  ];
  return cat;
}

export function ExpertCategory_PROJECTKEYVAL(name: string, BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', name, contents: [] };
  cat.contents = [
    BH.expertObj("EXPERT_PROJECTKEYVAL_SET_OBJ", "PROJECTKEYVAL.set({{obj[@check=RAGAIOBJ]}})", "await RAGAI.PROJECTKEYVAL.set({{obj}});", '{"key": "", "value": "", "type": "custom"}'),
    BH.expertObj("EXPERT_PROJECTKEYVAL_UNIQUE_OBJ", "PROJECTKEYVAL.unique({{obj[@check=RAGAIOBJ]}})", "await RAGAI.PROJECTKEYVAL.unique({{obj}});", '{"key": "", "value": "", "type": "custom"}'),
    BH.expertObj("EXPERT_PROJECTKEYVAL_GET_OBJ", "@output:String\nPROJECTKEYVAL.get({{obj[@check=RAGAIOBJ]}})", "await RAGAI.PROJECTKEYVAL.get({{obj}})", '{"key": "", "type": "custom"}'),
    BH.expertObj("EXPERT_PROJECTKEYVAL_GETBYTYPE_OBJ", "@output:String\nPROJECTKEYVAL.getByType({{obj[@check=RAGAIOBJ]}})", "await RAGAI.PROJECTKEYVAL.getByType({{obj}})", '{"type": "custom"}'),
    BH.expertObj("EXPERT_PROJECTKEYVAL_DELETE_OBJ", "PROJECTKEYVAL.deleteKeyValEntry({{obj[@check=RAGAIOBJ]}})", "await RAGAI.PROJECTKEYVAL.deleteKeyValEntry({{obj}});", '{"key": "", "type": "custom"}')
  ];
  return cat;
}

export function ExpertCategory_CARDS(name: string, BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', name, contents: [] };
  cat.contents = [
    BH.expertObj("EXPERT_CARDS_IMAGE_OBJ", "CARDS.image({{obj[@check=RAGAIOBJ]}})", "await RAGAI.CARDS.image({{obj}});", '{"src": "", "altText": "", "cssClass": ""}'),
    BH.expertObj("EXPERT_CARDS_IFRAME_OBJ", "CARDS.iframe({{obj[@check=RAGAIOBJ]}})", "await RAGAI.CARDS.iframe({{obj}});", '{"url": "", "cssClass": ""}'),
    BH.expertObj("EXPERT_CARDS_HTML_OBJ", "CARDS.html({{obj[@check=RAGAIOBJ]}})", "await RAGAI.CARDS.html({{obj}});", '{"html": "", "cssClass": "", "id": ""}'),
    BH.expertObj("EXPERT_CARDS_YOUTUBE_OBJ", "CARDS.youtube({{obj[@check=RAGAIOBJ]}})", "await RAGAI.CARDS.youtube({{obj}});", '{"id": "", "cssClass": ""}'),
    BH.expertObj("EXPERT_CARDS_VIMEO_OBJ", "CARDS.vimeo({{obj[@check=RAGAIOBJ]}})", "await RAGAI.CARDS.vimeo({{obj}});", '{"id": "", "hash": "", "cssClass": ""}'),
    BH._custom("EXPERT_CARDS_STAGELISTBUTTONS", "CARDS.stageListButtons()", "await RAGAI.CARDS.stageListButtons();"),
    BH.expertObj("EXPERT_CARDS_LOADING_OBJ", "CARDS.loading({{obj[@check=RAGAIOBJ]}})", "RAGAI.CARDS.loading({{obj}});", '{"text": "", "icon": "", "cssClass": ""}'),
    BH._custom("EXPERT_CARDS_REMOVELOADING", "CARDS.removeLoading()", "RAGAI.CARDS.removeLoading();"),
    BH.expertObj("EXPERT_CARDS_ADDBOTCARD_OBJ", "@output:String\nCARDS.addBotCard({{obj[@check=RAGAIOBJ]}})", "await RAGAI.CARDS.addBotCard({{obj}})", '{"type": "htmlCard", "data": {"html": ""}}')
  ];
  return cat;
}

export function ExpertCategory_OVERLAY(name: string, BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', name, contents: [] };
  cat.contents = [
    BH.expertObj("EXPERT_OVERLAY_TEXT_OBJ", "OVERLAY.text({{obj[@check=RAGAIOBJ]}})", "RAGAI.OVERLAY.text({{obj}});", '{"text": ""}'),
    BH.expertObj("EXPERT_OVERLAY_HTML_OBJ", "OVERLAY.html({{obj[@check=RAGAIOBJ]}})", "RAGAI.OVERLAY.html({{obj}});", '{"html": ""}'),
    BH.expertObj("EXPERT_OVERLAY_LOADING_OBJ", "OVERLAY.loading({{obj[@check=RAGAIOBJ]}})", "RAGAI.OVERLAY.loading({{obj}});", '{"text": "Wird geladen ..."}'),
    BH._custom("EXPERT_OVERLAY_CLOSE", "OVERLAY.close()", "RAGAI.OVERLAY.close();"),
    BH.expertObj("EXPERT_OVERLAY_SETPLACEMENT_OBJ", "OVERLAY.setPlacement({{obj[@check=RAGAIOBJ]}})", "RAGAI.OVERLAY.setPlacement({{obj}});", '{"placement": "botview"}'),
    BH._custom("EXPERT_OVERLAY_PROMPT_GETINPUTVALUE", "@output:String\nOVERLAY.prompt_getInputValue()", "RAGAI.OVERLAY.prompt_getInputValue()")
  ];
  return cat;
}

export function ExpertCategory_STAGE(name: string, BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', name, contents: [] };
  cat.contents = [
    BH.expertObj("EXPERT_STAGE_GOTONAME_OBJ", "STAGE.goToName({{obj[@check=RAGAIOBJ]}})", "await RAGAI.STAGE.goToName({{obj}});", '{"name": ""}'),
    BH.expertObj("EXPERT_STAGE_GOTOINDEX_OBJ", "STAGE.goToIndex({{obj[@check=RAGAIOBJ]}})", "await RAGAI.STAGE.goToIndex({{obj}});", '{"index": 0}'),
    BH.expertObj("EXPERT_STAGE_ADD_OBJ", "STAGE.add({{obj[@check=RAGAIOBJ]}})", "RAGAI.STAGE.add({{obj}});", '{"name": "", "title": "", "skills": [], "hidden": false, "footer": true}'),
    BH.expertObj("EXPERT_STAGE_REMOVE_OBJ", "STAGE.remove({{obj[@check=RAGAIOBJ]}})", "RAGAI.STAGE.remove({{obj}});", '{"name": ""}'),
    BH.expertObj("EXPERT_STAGE_HIDE_OBJ", "STAGE.hide({{obj[@check=RAGAIOBJ]}})", "RAGAI.STAGE.hide({{obj}});", '{"name": ""}'),
    BH.expertObj("EXPERT_STAGE_SHOW_OBJ", "STAGE.show({{obj[@check=RAGAIOBJ]}})", "RAGAI.STAGE.show({{obj}});", '{"name": ""}'),
    BH.expertObj("EXPERT_STAGE_GOTORANDOM_OBJ", "STAGE.goToRandom({{obj[@check=RAGAIOBJ]}})", "await RAGAI.STAGE.goToRandom({{obj}});", '{"possibleNames": []}'),
    BH.expertObj("EXPERT_STAGE_LIST_OBJ", "@output:String\nSTAGE.list({{obj[@check=RAGAIOBJ]}})", "RAGAI.STAGE.list({{obj}})", '{"includeHidden": false}'),
    BH._custom("EXPERT_STAGE_NEXT", "STAGE.next()", "await RAGAI.STAGE.next();"),
    BH._custom("EXPERT_STAGE_PREV", "STAGE.prev()", "await RAGAI.STAGE.prev();"),
    BH._custom("EXPERT_STAGE_RESTORE", "STAGE.restore()", "await RAGAI.STAGE.restore();")
  ];
  return cat;
}

export function ExpertCategory_EVENTS(name: string, BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', name, contents: [] };
  cat.contents = [
    BH.expertObj("EXPERT_EVENTS_ON_OBJ", "@output:String\nEVENTS.on({{obj[@check=RAGAIOBJ]}})", "RAGAI.EVENTS.on({{obj}})", '{"hook": "", "fn": "() => {}"}'),
    BH.expertObj("EXPERT_EVENTS_OFF_OBJ", "EVENTS.off({{obj[@check=RAGAIOBJ]}})", "RAGAI.EVENTS.off({{obj}});", '{"id": ""}'),
    BH.expertObj("EXPERT_EVENTS_TRIGGER_OBJ", "EVENTS.trigger({{obj[@check=RAGAIOBJ]}})", "RAGAI.EVENTS.trigger({{obj}});", '{"name": "", "params": {}}'),
    BH.expertObj("EXPERT_EVENTS_INACTIVEHOOK_OBJ", "EVENTS.inActiveHook({{obj[@check=RAGAIOBJ]}})", "await RAGAI.EVENTS.inActiveHook({{obj}});", '{"seconds": 30}')
  ];
  return cat;
}

export function ExpertCategory_WAITFOR(name: string, BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', name, contents: [] };
  cat.contents = [
    BH._custom("EXPERT_WAITFOR_NEXTIDLE", "WAITFOR.nextIdle()", "await RAGAI.WAITFOR.nextIdle();"),
    BH._custom("EXPERT_WAITFOR_INITIALIDLE", "WAITFOR.initialIdle()", "await RAGAI.WAITFOR.initialIdle();"),
    BH._custom("EXPERT_WAITFOR_VARSINIT", "WAITFOR.varsInit()", "await RAGAI.WAITFOR.varsInit();"),
    BH.expertObj("EXPERT_WAITFOR_EVENT_OBJ", "@output:String\nWAITFOR.event({{obj[@check=RAGAIOBJ]}})", "await RAGAI.WAITFOR.event({{obj}})", '{"hook": ""}'),
    BH.expertObj("EXPERT_WAITFOR_SECONDS_OBJ", "WAITFOR.secondsAndExec({{obj[@check=RAGAIOBJ]}})", "RAGAI.WAITFOR.secondsAndExec({{obj}});", '{"seconds": 5, "fn": "() => {}"}'),
    BH.expertObj("EXPERT_WAITFOR_MINUTES_OBJ", "WAITFOR.minutesAndExec({{obj[@check=RAGAIOBJ]}})", "RAGAI.WAITFOR.minutesAndExec({{obj}});", '{"minutes": 1, "fn": "() => {}"}')
  ];
  return cat;
}

export function ExpertCategory_HELPER(name: string, BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', name, contents: [] };
  cat.contents = [
    BH._custom("EXPERT_HELPER_CLOSEWINDOW", "HELPER.closeWindow()", "RAGAI.HELPER.closeWindow();"),
    BH.expertObj("EXPERT_HELPER_COPYTOCLIPBOARD_OBJ", "HELPER.copyToClipboard({{obj[@check=RAGAIOBJ]}})", "RAGAI.HELPER.copyToClipboard({{obj}});", '{"text": ""}'),
    BH.expertObj("EXPERT_HELPER_ADDSTAT_OBJ", "HELPER.addStat({{obj[@check=RAGAIOBJ]}})", "await RAGAI.HELPER.addStat({{obj}});", '{"stat": ""}'),
    BH._custom("EXPERT_HELPER_ENDBOT", "HELPER.endBot()", "RAGAI.HELPER.endBot();"),
    BH.expertObj("EXPERT_HELPER_GETIMAGEURL_OBJ", "@output:String\nHELPER.getImageURlFromSkill({{obj[@check=RAGAIOBJ]}})", "await RAGAI.HELPER.getImageURlFromSkill({{obj}})", '{"skillId": ""}'),
    BH._custom("EXPERT_HELPER_CURRENTLANGUAGE", "@output:String\nHELPER.currentLanguage()", "RAGAI.HELPER.currentLanguage()")
  ];
  return cat;
}

export function ExpertCategory_DOWNLOAD(name: string, BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', name, contents: [] };
  cat.contents = [
    BH.expertObj("EXPERT_DOWNLOAD_TEXTASFILE_OBJ", "DOWNLOAD.textAsFile({{obj[@check=RAGAIOBJ]}})", "RAGAI.DOWNLOAD.textAsFile({{obj}});", '{"text": "", "filename": "file.txt"}'),
    BH.expertObj("EXPERT_DOWNLOAD_MATERIAL_OBJ", "DOWNLOAD.downloadMaterial({{obj[@check=RAGAIOBJ]}})", "await RAGAI.DOWNLOAD.downloadMaterial({{obj}});", '{"skillId": ""}'),
    BH.expertObj("EXPERT_DOWNLOAD_GETMDCONTENT_OBJ", "@output:String\nDOWNLOAD.getMDContent({{obj[@check=RAGAIOBJ]}})", "await RAGAI.DOWNLOAD.getMDContent({{obj}})", '{"skillId": ""}'),
    BH.expertObj("EXPERT_DOWNLOAD_FILLEDPDF_OBJ", "DOWNLOAD.downloadFilledPDFTemplate({{obj[@check=RAGAIOBJ]}})", "await RAGAI.DOWNLOAD.downloadFilledPDFTemplate({{obj}});", '{"skillId": "", "filename": ""}')
  ];
  return cat;
}

export function ExpertCategory_WEBHOOK(name: string, BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', name, contents: [] };
  cat.contents = [
    BH.expertObj("EXPERT_WEBHOOK_CALL_OBJ", "@output:String\nWEBHOOK.call({{obj[@check=RAGAIOBJ]}})", "await RAGAI.WEBHOOK.call({{obj}})", '{"skillId": "", "request": {}}')
  ];
  return cat;
}

export function ExpertCategory_AUDIO(name: string, BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', name, contents: [] };
  cat.contents = [
    BH.expertObj("EXPERT_AUDIO_SAY_OBJ", "AUDIO.say({{obj[@check=RAGAIOBJ]}})", "await RAGAI.AUDIO.say({{obj}});", '{"text": "", "voice": ""}'),
    BH.expertObj("EXPERT_AUDIO_BOTSAY_OBJ", "AUDIO.botSay({{obj[@check=RAGAIOBJ]}})", "await RAGAI.AUDIO.botSay({{obj}});", '{"text": "", "voice": ""}'),
    BH.expertObj("EXPERT_AUDIO_SETTEXT_OBJ", "AUDIO.setText({{obj[@check=RAGAIOBJ]}})", "RAGAI.AUDIO.setText({{obj}});", '{"text": ""}'),
    BH.expertObj("EXPERT_AUDIO_SETINSTRUCTION_OBJ", "AUDIO.setInstruction({{obj[@check=RAGAIOBJ]}})", "await RAGAI.AUDIO.setInstruction({{obj}});", '{"text": ""}'),
    BH._custom("EXPERT_AUDIO_GETINSTRUCTION", "@output:String\nAUDIO.getInstruction()", "await RAGAI.AUDIO.getInstruction()"),
    BH._custom("EXPERT_AUDIO_MUTEMMIC", "AUDIO.muteMic()", "RAGAI.AUDIO.muteMic();"),
    BH._custom("EXPERT_AUDIO_UNMUTEMMIC", "AUDIO.unmuteMic()", "RAGAI.AUDIO.unmuteMic();"),
    BH._custom("EXPERT_AUDIO_ISMICMUTED", "@output:String\nAUDIO.isMicMuted()", "RAGAI.AUDIO.isMicMuted()"),
    BH._custom("EXPERT_AUDIO_STOPSPEAKING", "AUDIO.stopSpeaking()", "RAGAI.AUDIO.stopSpeaking();")
  ];
  return cat;
}

export function ExpertCategory_CHAT_AVATAR(name: string, BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', name, contents: [] };
  cat.contents = [
    BH.expertObj("EXPERT_CHATAVATAR_SETBOTIMG_OBJ", "CHAT_AVATAR.setBotImg({{obj[@check=RAGAIOBJ]}})", "await RAGAI.CHAT_AVATAR.setBotImg({{obj}});", '{"skillId": ""}'),
    BH.expertObj("EXPERT_CHATAVATAR_SETUSERIMG_OBJ", "CHAT_AVATAR.setUserImg({{obj[@check=RAGAIOBJ]}})", "await RAGAI.CHAT_AVATAR.setUserImg({{obj}});", '{"skillId": ""}'),
    BH._custom("EXPERT_CHATAVATAR_UNSETBOTIMG", "CHAT_AVATAR.unsetBotImg()", "await RAGAI.CHAT_AVATAR.unsetBotImg();"),
    BH._custom("EXPERT_CHATAVATAR_UNSETUSERIMG", "CHAT_AVATAR.unsetUserImg()", "await RAGAI.CHAT_AVATAR.unsetUserImg();")
  ];
  return cat;
}

export function ExpertCategory_VIDEO_AVATAR(name: string, BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', name, contents: [] };
  cat.contents = [
    BH.expertObj("EXPERT_VIDEOAVATAR_SETBG_OBJ", "VIDEO_AVATAR.setBackgroundImage({{obj[@check=RAGAIOBJ]}})", "await RAGAI.VIDEO_AVATAR.setBackgroundImage({{obj}});", '{"source": ""}'),
    BH._custom("EXPERT_VIDEOAVATAR_UNSETIMG", "VIDEO_AVATAR.unsetImage()", "await RAGAI.VIDEO_AVATAR.unsetImage();"),
    BH._custom("EXPERT_VIDEOAVATAR_GETBG", "@output:String\nVIDEO_AVATAR.getBackgroundImage()", "await RAGAI.VIDEO_AVATAR.getBackgroundImage()"),
    BH.expertObj("EXPERT_VIDEOAVATAR_SETTEXT_OBJ", "VIDEO_AVATAR.setText({{obj[@check=RAGAIOBJ]}})", "RAGAI.VIDEO_AVATAR.setText({{obj}});", '{"text": ""}'),
  ];
  return cat;
}

export function ExpertCategory_SCORE(name: string, BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', name, contents: [] };
  cat.contents = [
    BH.expertObj("EXPERT_SCORE_ADD_OBJ", "SCORE.add({{obj[@check=RAGAIOBJ]}})", "RAGAI.SCORE.add({{obj}});", '{"value": 1}'),
    BH.expertObj("EXPERT_SCORE_SUB_OBJ", "SCORE.sub({{obj[@check=RAGAIOBJ]}})", "RAGAI.SCORE.sub({{obj}});", '{"value": 1}'),
    BH.expertObj("EXPERT_SCORE_SET_OBJ", "SCORE.set({{obj[@check=RAGAIOBJ]}})", "RAGAI.SCORE.set({{obj}});", '{"value": 0}'),
    BH._custom("EXPERT_SCORE_GET", "@output:String\nSCORE.get()", "RAGAI.SCORE.get()"),
    BH._custom("EXPERT_SCORE_RESET", "SCORE.reset()", "RAGAI.SCORE.reset();"),
    BH.expertObj("EXPERT_SCORE_DB_OBJ", "@output:String\nSCORE.db({{obj[@check=RAGAIOBJ]}})", "RAGAI.SCORE.db({{obj}})", '{"name": ""}'),
    BH.expertObj("EXPERT_SCORE_ACHIEVE_OBJ", "SCORE.achieve({{obj[@check=RAGAIOBJ]}})", "RAGAI.SCORE.achieve({{obj}});", '{"value": 1, "skillId": "", "message": "", "autoMessage": false}')
  ];
  return cat;
}

export function ExpertCategory_SKILL(name: string, BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', name, contents: [] };
  cat.contents = [
    BH._custom("EXPERT_SKILL_GETSKILLS", "@output:String\nSKILL.getSkills()", "await RAGAI.SKILL.getSkills()"),
    BH.expertObj("EXPERT_SKILL_ENABLESKILLS_OBJ", "SKILL.enableSkills({{obj[@check=RAGAIOBJ]}})", "await RAGAI.SKILL.enableSkills({{obj}});", '{"skillIds": []}'),
    BH.expertObj("EXPERT_SKILL_DISABLESKILLS_OBJ", "SKILL.disableSkills({{obj[@check=RAGAIOBJ]}})", "await RAGAI.SKILL.disableSkills({{obj}});", '{"skillIds": []}'),
    BH._custom("EXPERT_SKILL_DISABLEALL", "SKILL.disableAllSkills()", "await RAGAI.SKILL.disableAllSkills();"),
    BH.expertObj("EXPERT_SKILL_ENABLEANDCHILDREN_OBJ", "SKILL.enableSkillAndChildren({{obj[@check=RAGAIOBJ]}})", "await RAGAI.SKILL.enableSkillAndChildren({{obj}});", '{"skillId": "", "depth": "Infinity"}'),
    BH.expertObj("EXPERT_SKILL_DISABLEANDCHILDREN_OBJ", "SKILL.disableSkillAndChildren({{obj[@check=RAGAIOBJ]}})", "await RAGAI.SKILL.disableSkillAndChildren({{obj}});", '{"skillId": "", "depth": "Infinity"}'),
    BH.expertObj("EXPERT_SKILL_FORNEXTRUN_OBJ", "SKILL.skillsForNextRun({{obj[@check=RAGAIOBJ]}})", "await RAGAI.SKILL.skillsForNextRun({{obj}});", '{"skillIds": []}'),
    BH._custom("EXPERT_SKILL_UNFORCEALL", "SKILL.unforceAllSkills()", "await RAGAI.SKILL.unforceAllSkills();")
  ];
  return cat;
}

export function ExpertCategory_DOM(name: string, BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', name, contents: [] };
  cat.contents = [
    BH._custom("EXPERT_DOM_HIDEFOOTER", "DOM.hideFooter()", "RAGAI.DOM.hideFooter();"),
    BH._custom("EXPERT_DOM_SHOWFOOTER", "DOM.showFooter()", "RAGAI.DOM.showFooter();"),
    BH._custom("EXPERT_DOM_HIDEHEADER", "DOM.hideHeader()", "RAGAI.DOM.hideHeader();"),
    BH._custom("EXPERT_DOM_SHOWHEADER", "DOM.showHeader()", "RAGAI.DOM.showHeader();"),
    BH.expertObj("EXPERT_DOM_STYLEVAR_OBJ", "DOM.styleVar({{obj[@check=RAGAIOBJ]}})", "RAGAI.DOM.styleVar({{obj}});", '{"key": "", "value": ""}'),
    BH.expertObj("EXPERT_DOM_SETBODYCOLOR_OBJ", "DOM.setBodyColor({{obj[@check=RAGAIOBJ]}})", "RAGAI.DOM.setBodyColor({{obj}});", '{"color": ""}'),
    BH.expertObj("EXPERT_DOM_LOADEXTERNALJS_OBJ", "DOM.loadExternalJS({{obj[@check=RAGAIOBJ]}})", "await RAGAI.DOM.loadExternalJS({{obj}});", '{"url": ""}'),
    BH.expertObj("EXPERT_DOM_LOADEXTERNALCSS_OBJ", "DOM.loadExternalCSS({{obj[@check=RAGAIOBJ]}})", "await RAGAI.DOM.loadExternalCSS({{obj}});", '{"url": ""}')
  ];
  return cat;
}

export function ExpertCategory_DOCSEARCH(name: string, BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', name, contents: [] };
  cat.contents = [
    BH.expertObj("EXPERT_DOCSEARCH_SEARCHASJSON_OBJ", "@output:String\nDOCSEARCH.searchAsJson({{obj[@check=RAGAIOBJ]}})", "await RAGAI.DOCSEARCH.searchAsJson({{obj}})", '{"query": "", "skillIds": null, "count": 5, "minScore": 0}'),
    BH.expertObj("EXPERT_DOCSEARCH_SEARCHASCARD_OBJ", "DOCSEARCH.searchAsCard({{obj[@check=RAGAIOBJ]}})", "await RAGAI.DOCSEARCH.searchAsCard({{obj}});", '{"query": "", "skillIds": null, "count": 5, "minScore": 0}')
  ];
  return cat;
}

export function ExpertCategory_AITEXT_OPENAI(name: string, BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', name, contents: [] };
  cat.contents = [
    BH.expertObj("EXPERT_AITEXT_OPENAI_CHAT_OBJ", "@output:String\nAITEXT_OPENAI.chatCompletion({{obj[@check=RAGAIOBJ]}})", "await RAGAI.AITEXT_OPENAI.chatCompletion({{obj}})", '{"input": "", "model": "gpt-4o", "temperature": 0.7}'),
    BH.expertObj("EXPERT_AITEXT_OPENAI_CHATJSON_OBJ", "@output:String\nAITEXT_OPENAI.chatCompletionJson({{obj[@check=RAGAIOBJ]}})", "await RAGAI.AITEXT_OPENAI.chatCompletionJson({{obj}})", '{"input": "", "model": "gpt-4o", "temperature": 0.7}'),
    BH.expertObj("EXPERT_AITEXT_OPENAI_STRUCTUREDRESPONSE_OBJ", "@output:String\nAITEXT_OPENAI.structuredResponse({{obj[@check=RAGAIOBJ]}})", "await RAGAI.AITEXT_OPENAI.structuredResponse({{obj}})", '{"promptInput": "", "jsonSchema": {"name": "person", "schema": {"type": "object", "properties": {"name": {"type": "string"}}, "required": ["name"], "additionalProperties": false}}, "model": "gpt-4o-mini", "temperature": 0.2, "instructions": "", "webSearch": false}')
  ];
  return cat;
}

export function ExpertCategory_AITEXT_VLLM(name: string, BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', name, contents: [] };
  cat.contents = [
    BH.expertObj("EXPERT_AITEXT_VLLM_CHAT_OBJ", "@output:String\nAITEXT_VLLM.chatCompletion({{obj[@check=RAGAIOBJ]}})", "await RAGAI.AITEXT_VLLM.chatCompletion({{obj}})", '{"input": ""}'),
    BH.expertObj("EXPERT_AITEXT_VLLM_CHATJSON_OBJ", "@output:String\nAITEXT_VLLM.chatCompletionJson({{obj[@check=RAGAIOBJ]}})", "await RAGAI.AITEXT_VLLM.chatCompletionJson({{obj}})", '{"input": ""}')
  ];
  return cat;
}

export function ExpertCategory_AIIMAGE(name: string, BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', name, contents: [] };
  cat.contents = [
    BH.expertObj("EXPERT_AIIMAGE_OPENAI_CREATE_OBJ", "@output:String\nAIIMAGE_OPENAI.create({{obj[@check=RAGAIOBJ]}})", "await RAGAI.AIIMAGE_OPENAI.create({{obj}})", '{"prompt": "", "images": [], "aspectRatio": "1:1", "quality": "auto"}'),
    BH.expertObj("EXPERT_AIIMAGE_OPENAI_GETURL_OBJ", "@output:String\nAIIMAGE_OPENAI.getImageUrl({{obj[@check=RAGAIOBJ]}})", "RAGAI.AIIMAGE_OPENAI.getImageUrl({{obj}})", '{"fileId": ""}'),
    BH.expertObj("EXPERT_AIIMAGE_OPENAI_ANALYZE_OBJ", "@output:String\nAIIMAGE_OPENAI.analyzeImage({{obj[@check=RAGAIOBJ]}})", "await RAGAI.AIIMAGE_OPENAI.analyzeImage({{obj}})", '{"image": "", "prompt": ""}'),
    BH.expertObj("EXPERT_AIIMAGE_FALAI_CREATE_OBJ", "@output:String\nAIIMAGE_FALAI.create({{obj[@check=RAGAIOBJ]}})", "await RAGAI.AIIMAGE_FALAI.create({{obj}})", '{"prompt": "", "images": [], "aspectRatio": "1:1"}'),
    BH.expertObj("EXPERT_AIIMAGE_FALAI_GETURL_OBJ", "@output:String\nAIIMAGE_FALAI.getImageUrl({{obj[@check=RAGAIOBJ]}})", "RAGAI.AIIMAGE_FALAI.getImageUrl({{obj}})", '{"fileId": ""}'),
    BH.expertObj("EXPERT_AIIMAGE_SD_CREATE_OBJ", "@output:String\nAIIMAGE_STABLEDIFFUSION.create({{obj[@check=RAGAIOBJ]}})", "await RAGAI.AIIMAGE_STABLEDIFFUSION.create({{obj}})", '{"prompt": "", "images": [], "aspectRatio": "1:1"}'),
    BH.expertObj("EXPERT_AIIMAGE_SD_GETURL_OBJ", "@output:String\nAIIMAGE_STABLEDIFFUSION.getImageUrl({{obj[@check=RAGAIOBJ]}})", "RAGAI.AIIMAGE_STABLEDIFFUSION.getImageUrl({{obj}})", '{"fileId": ""}')
  ];
  return cat;
}

export function ExpertCategory_SCORM(name: string, BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', name, contents: [] };
  cat.contents = [
    BH._custom("EXPERT_SCORM_INIT", "SCORM.LMSInitialize()", "RAGAI.SCORM.LMSInitialize();"),
    BH._custom("EXPERT_SCORM_FINISH", "SCORM.LMSFinish()", "RAGAI.SCORM.LMSFinish();"),
    BH._custom("EXPERT_SCORM_COMMIT", "SCORM.LMSCommit()", "RAGAI.SCORM.LMSCommit();"),
    BH._custom("EXPERT_SCORM_ISINIT", "@output:String\nSCORM.runsInLms()", "RAGAI.SCORM.runsInLms()"),
    BH.expertObj("EXPERT_SCORM_GET_OBJ", "@output:String\nSCORM.LMSGetValue({{obj[@check=RAGAIOBJ]}})", "RAGAI.SCORM.LMSGetValue({{obj}})", '{"key": ""}'),
    BH.expertObj("EXPERT_SCORM_SET_OBJ", "SCORM.LMSSetValue({{obj[@check=RAGAIOBJ]}})", "RAGAI.SCORM.LMSSetValue({{obj}});", '{"key": "", "value": ""}')
  ];
  return cat;
}

export function ExpertCategory_MAIL(name: string, BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', name, contents: [] };
  cat.contents = [
    BH.expertObj("EXPERT_MAIL_SEND_OBJ", "@output:String\nMAIL.send({{obj[@check=RAGAIOBJ]}})", "await RAGAI.MAIL.send({{obj}})", '{"to": "", "subject": "", "body": ""}'),
    BH.expertObj("EXPERT_MAIL_GETENVELOPE_OBJ", "@output:String\nMAIL.getEnvelope({{obj[@check=RAGAIOBJ]}})", "await RAGAI.MAIL.getEnvelope({{obj}})", '{"to": "", "subject": "", "body": ""}'),
    BH.expertObj("EXPERT_MAIL_WEBHOOK_OBJ", "MAIL.webhook({{obj[@check=RAGAIOBJ]}})", "await RAGAI.MAIL.webhook({{obj}});", '{"webhook": "", "envelope": {}}')
  ];
  return cat;
}

export function ExpertCategory_FUSIONVIEW(name: string, BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', name, contents: [] };
  cat.contents = [
    BH.expertObj("EXPERT_FUSIONVIEW_GOTO_OBJ", "FUSIONVIEW.goToFusionView({{obj[@check=RAGAIOBJ]}})", "RAGAI.FUSIONVIEW.goToFusionView({{obj}});", '{"fusionViewId": ""}')
  ];
  return cat;
}

export function ExpertCategory_YOUTUBE(name: string, BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', name, contents: [] };
  cat.contents = [
    BH._custom("EXPERT_YOUTUBE_PLAY", "YOUTUBE.play()", "await RAGAI.YOUTUBE.play();"),
    BH._custom("EXPERT_YOUTUBE_PAUSE", "YOUTUBE.pause()", "await RAGAI.YOUTUBE.pause();"),
    BH._custom("EXPERT_YOUTUBE_STOP", "YOUTUBE.stop()", "await RAGAI.YOUTUBE.stop();"),
    BH._custom("EXPERT_YOUTUBE_MUTE", "YOUTUBE.mute()", "await RAGAI.YOUTUBE.mute();"),
    BH._custom("EXPERT_YOUTUBE_UNMUTE", "YOUTUBE.unmute()", "await RAGAI.YOUTUBE.unmute();"),
    BH.expertObj("EXPERT_YOUTUBE_SETVOLUME_OBJ", "YOUTUBE.setVolume({{obj[@check=RAGAIOBJ]}})", "await RAGAI.YOUTUBE.setVolume({{obj}});", '{"volume": 100}'),
    BH.expertObj("EXPERT_YOUTUBE_SETRATE_OBJ", "YOUTUBE.setPlaybackRate({{obj[@check=RAGAIOBJ]}})", "await RAGAI.YOUTUBE.setPlaybackRate({{obj}});", '{"rate": 1}'),
    BH.expertObj("EXPERT_YOUTUBE_SEEKTO_OBJ", "YOUTUBE.seekTo({{obj[@check=RAGAIOBJ]}})", "await RAGAI.YOUTUBE.seekTo({{obj}});", '{"hours": 0, "minutes": 0, "seconds": 0}'),
    BH.expertObj("EXPERT_YOUTUBE_LOADVIDEO_OBJ", "YOUTUBE.loadVideo({{obj[@check=RAGAIOBJ]}})", "await RAGAI.YOUTUBE.loadVideo({{obj}});", '{"videoId": ""}')
  ];
  return cat;
}

export function ExpertCategory_VIMEO(name: string, BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', name, contents: [] };
  cat.contents = [
    BH._custom("EXPERT_VIMEO_PLAY", "VIMEO.play()", "await RAGAI.VIMEO.play();"),
    BH._custom("EXPERT_VIMEO_PAUSE", "VIMEO.pause()", "await RAGAI.VIMEO.pause();"),
    BH.expertObj("EXPERT_VIMEO_SEEKTO_OBJ", "VIMEO.seekTo({{obj[@check=RAGAIOBJ]}})", "await RAGAI.VIMEO.seekTo({{obj}});", '{"hours": 0, "minutes": 0, "seconds": 0}'),
    BH.expertObj("EXPERT_VIMEO_SETVOLUME_OBJ", "VIMEO.setVolume({{obj[@check=RAGAIOBJ]}})", "await RAGAI.VIMEO.setVolume({{obj}});", '{"volume": 100}'),
    BH.expertObj("EXPERT_VIMEO_SETRATE_OBJ", "VIMEO.setPlaybackRate({{obj[@check=RAGAIOBJ]}})", "await RAGAI.VIMEO.setPlaybackRate({{obj}});", '{"rate": 1}'),
    BH._custom("EXPERT_VIMEO_POSITION", "@output:String\nVIMEO.currentPlayPosition()", "await RAGAI.VIMEO.currentPlayPosition()")
  ];
  return cat;
}

export function ExpertCategory_DIALOGRECORDER(name: string, BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', name, contents: [] };
  cat.contents = [
    BH.expertObj("EXPERT_DIALOGRECORDER_INIT_OBJ", "DIALOGRECORDER.init({{obj[@check=RAGAIOBJ]}})", "await RAGAI.DIALOGRECORDER.init({{obj}});", '{"recorderId": ""}'),
    BH.expertObj("EXPERT_DIALOGRECORDER_RECORD_OBJ", "DIALOGRECORDER.record({{obj[@check=RAGAIOBJ]}})", "await RAGAI.DIALOGRECORDER.record({{obj}});", '{"recorderId": ""}'),
    BH.expertObj("EXPERT_DIALOGRECORDER_STOP_OBJ", "DIALOGRECORDER.stop({{obj[@check=RAGAIOBJ]}})", "await RAGAI.DIALOGRECORDER.stop({{obj}});", '{"recorderId": ""}'),
    BH.expertObj("EXPERT_DIALOGRECORDER_RESET_OBJ", "DIALOGRECORDER.reset({{obj[@check=RAGAIOBJ]}})", "await RAGAI.DIALOGRECORDER.reset({{obj}});", '{"recorderId": ""}'),
    BH.expertObj("EXPERT_DIALOGRECORDER_GETDIALOGTEXT_OBJ", "@output:String\nDIALOGRECORDER.getDialogText({{obj[@check=RAGAIOBJ]}})", "await RAGAI.DIALOGRECORDER.getDialogText({{obj}})", '{"recorderId": "", "userName": "User", "botName": "Bot"}'),
    BH.expertObj("EXPERT_DIALOGRECORDER_GETDIALOGHTML_OBJ", "@output:String\nDIALOGRECORDER.getDialogHtml({{obj[@check=RAGAIOBJ]}})", "await RAGAI.DIALOGRECORDER.getDialogHtml({{obj}})", '{"recorderId": "", "userName": "User", "botName": "Bot"}'),
    BH.expertObj("EXPERT_DIALOGRECORDER_GETDIALOGJSON_OBJ", "@output:String\nDIALOGRECORDER.getDialogJson({{obj[@check=RAGAIOBJ]}})", "await RAGAI.DIALOGRECORDER.getDialogJson({{obj}})", '{"recorderId": ""}')
  ];
  return cat;
}

export function ExpertCategory_DIALOGSTORE(name: string, BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', name, contents: [] };
  cat.contents = [
    BH._custom("EXPERT_DIALOGSTORE_GETCURRENT", "@output:String\nDIALOGSTORE.getCurrentDialog()", "await RAGAI.DIALOGSTORE.getCurrentDialog()"),
    BH.expertObj("EXPERT_DIALOGSTORE_STORE_OBJ", "@output:String\nDIALOGSTORE.storeDialogToLocalStorage({{obj[@check=RAGAIOBJ]}})", "await RAGAI.DIALOGSTORE.storeDialogToLocalStorage({{obj}})", '{"key": ""}'),
    BH.expertObj("EXPERT_DIALOGSTORE_RESTORE_OBJ", "@output:String\nDIALOGSTORE.restoreDialogFromLocalStorage({{obj[@check=RAGAIOBJ]}})", "await RAGAI.DIALOGSTORE.restoreDialogFromLocalStorage({{obj}})", '{"dialogId": ""}')
  ];
  return cat;
}

export function ExpertCategory_SUPERVISOR(name: string, BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', name, contents: [] };
  cat.contents = [
    BH.expertObj("EXPERT_SUPERVISOR_NOTIFY_OBJ", "SUPERVISOR.notify({{obj[@check=RAGAIOBJ]}})", "await RAGAI.SUPERVISOR.notify({{obj}});", '{"messageName": ""}'),
    BH.expertObj("EXPERT_SUPERVISOR_SETINFO_OBJ", "SUPERVISOR.setInfo({{obj[@check=RAGAIOBJ]}})", "await RAGAI.SUPERVISOR.setInfo({{obj}});", '{"key": "", "value": ""}'),
    BH.expertObj("EXPERT_SUPERVISOR_GETINFO_OBJ", "@output:String\nSUPERVISOR.getInfo({{obj[@check=RAGAIOBJ]}})", "await RAGAI.SUPERVISOR.getInfo({{obj}})", '{"key": ""}')
  ];
  return cat;
}

export function ExpertCategory_QUIZ(name: string, BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', name, contents: [] };
  cat.contents = [
    BH.expertObj("EXPERT_QUIZ_STARTFROMTEXT_OBJ", "QUIZ.startFromText({{obj[@check=RAGAIOBJ]}})", "await RAGAI.QUIZ.startFromText({{obj}});", '{"source": ""}'),
    BH._custom("EXPERT_QUIZ_NEXTQUESTION", "QUIZ.nextQuestion()", "await RAGAI.QUIZ.nextQuestion();"),
    BH._custom("EXPERT_QUIZ_END", "QUIZ.end()", "RAGAI.QUIZ.end();"),
    BH._custom("EXPERT_QUIZ_CLEANUP", "QUIZ.cleanupQuiz()", "RAGAI.QUIZ.cleanupQuiz();"),
    BH._custom("EXPERT_QUIZ_ISRUNNING", "@output:String\nQUIZ.IS_RUNNING", "RAGAI.QUIZ.IS_RUNNING"),
    BH._custom("EXPERT_QUIZ_ASKED", "@output:String\nQUIZ.ASKED_QUESTIONS", "RAGAI.QUIZ.ASKED_QUESTIONS"),
    BH._custom("EXPERT_QUIZ_ANSWERED", "@output:String\nQUIZ.ANSWERED_QUESTIONS", "RAGAI.QUIZ.ANSWERED_QUESTIONS")
  ];
  return cat;
}

export function ExpertCategory_PARENT(name: string, BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', name, contents: [] };
  cat.contents = [
    BH.expertObj("EXPERT_PARENT_EXEC_OBJ", "PARENT.exec({{obj[@check=RAGAIOBJ]}})", "RAGAI.PARENT.exec({{obj}});", '{"code": ""}'),
    BH.expertObj("EXPERT_PARENT_GET_OBJ", "@output:String\nPARENT.get({{obj[@check=RAGAIOBJ]}})", "await RAGAI.PARENT.get({{obj}})", '{"code": ""}')
  ];
  return cat;
}

export function ExpertCategory_BOTAPI(name: string, BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', name, contents: [] };
  cat.contents = [
    BH.expertObj("EXPERT_BOTAPI_POSTMESSAGE_OBJ", "@output:String\nBOTAPI.postMessage({{obj[@check=RAGAIOBJ]}})", "await RAGAI.BOTAPI.postMessage({{obj}})", '{"method": "", "payload": {}}'),
    BH.expertObj("EXPERT_BOTAPI_CALLEXTERNAL_OBJ", "@output:String\nBOTAPI.callExternalFunction({{obj[@check=RAGAIOBJ]}})", "await RAGAI.BOTAPI.callExternalFunction({{obj}})", '{"name": ""}'),
    BH._custom("EXPERT_BOTAPI_GETFUNCTIONS", "@output:String\nBOTAPI.getRegisteredFunctionNames()", "await RAGAI.BOTAPI.getRegisteredFunctionNames()")
  ];
  return cat;
}

export function ExpertCategory_BEFORE_SEND(name: string, BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', name, contents: [] };
  cat.contents = [
    BH._custom("EXPERT_BEFORESEND_CLEAR", "BEFORE_SEND.clear()", "RAGAI.BEFORE_SEND.clear();"),
    BH._custom("EXPERT_BEFORESEND_LIST", "@output:String\nBEFORE_SEND.list()", "RAGAI.BEFORE_SEND.list()")
  ];
  return cat;
}

export function ExpertCategory_LOG(name: string, BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', name, contents: [] };
  cat.contents = [
    BH._custom("EXPERT_LOG_ENABLE", "LOG.enable()", "RAGAI.LOG.enable();"),
    BH._custom("EXPERT_LOG_DISABLE", "LOG.disable()", "RAGAI.LOG.disable();"),
    BH.expertObj("EXPERT_LOG_FILTER_OBJ", "LOG.filter({{obj[@check=RAGAIOBJ]}})", "RAGAI.LOG.filter({{obj}});", '{"filter": ""}')
  ];
  return cat;
}

export function ExpertCategory_INFO(name: string, BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', name, contents: [] };
  cat.contents = [
    BH._custom("EXPERT_INFO_MESSAGESCOUNT", "@output:String\nINFO.messagesCount()", "RAGAI.INFO.messagesCount()")
  ];
  return cat;
}

export function ExpertCategory_MISC(name: string, BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', name, contents: [] };
  cat.contents = [
    //  BH._custom("EXPERT_CONFETTI", "confetti()", "RAGAI.confetti();"),
    //    BH._custom("EXPERT_CANCEL", "cancel()", "RAGAI.cancel();"),
    //BH._custom("EXPERT_RESETBOT", "resetBot()", "await RAGAI.resetBot();"),
    //BH._custom("EXPERT_RESTARTBOT", "restartBot()", "await RAGAI.restartBot();"),
    //BH._custom("EXPERT_RAW_JS", "🌀 JavaScript: {{code:text}}", "{{code!}}", { colour: '#000000' }),
    //BH._custom("EXPERT_RAW_JS_OUTPUT", "@output:String\n🌀 JavaScript: {{code:text}}", "{{code!}}", { colour: '#000000' })
  ];
  return cat;
}

export function ExpertCategory_GROUPCHAT(name: string, BH: BlocklyHelperService, registry: GroupchatChannelRegistryService): BlocklyToolboxCategory {
  registerGroupchatChannelDropdownBlock(registry);
  const cat: BlocklyToolboxCategory = { kind: 'category', name, contents: [] };
  cat.contents = [
    BH.withNested(
      BH.ragAi("EXPERT_GROUPCHAT_SEND", "GROUPCHAT.send({{nachricht}}, {{kanal}})", "await RAGAI.GROUPCHAT.send({{nachricht}}, {{kanal}});"),
      [
        { forValue: "nachricht", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING },
        { forValue: "kanal", isShadow: true, targetBlockType: 'GROUPCHAT_CHANNEL_DROPDOWN' }
      ]
    ),
    BH.withNested(
      BH.ragAi("EXPERT_GROUPCHAT_READ", "@output:String\nGROUPCHAT.read({{kanal}})", "await RAGAI.GROUPCHAT.read({{kanal}})"),
      [{ forValue: "kanal", isShadow: true, targetBlockType: 'GROUPCHAT_CHANNEL_DROPDOWN' }]
    ),
    BH.withNested(
      BH.ragAi("EXPERT_GROUPCHAT_DELETE", "GROUPCHAT.delete({{kanal}})", "await RAGAI.GROUPCHAT.delete({{kanal}});"),
      [{ forValue: "kanal", isShadow: true, targetBlockType: 'GROUPCHAT_CHANNEL_DROPDOWN' }]
    )
  ];
  return cat;
}
